import { LocationPermissionStatus } from './getLocationPermission.types';

const debug = require('debug')('tca:kit:utilities:requestLocationPermission');

export const requestLocationPermission =
  async (): Promise<LocationPermissionStatus> => {
    try {
      await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        });
      });

      debug('Web location permission granted');

      return 'granted';
    } catch (error) {
      debug(`Web location permission request error: ${JSON.stringify(error)}`);

      // On web, we can't distinguish between denied and blocked
      // We'll treat all errors as denied since that's the most common case
      return 'denied';
    }
  };
